import React, { useEffect, useState } from "react";
import { Select } from "antd";
import { useDispatch } from "react-redux";

const { Option } = Select;

const customCountries = [
  { label: "(+31) Netherlands", value: "+31" },
  { label: "(+49) Germany", value: "+49" },
  { label: "(+33) France", value: "+33" },
  { label: "(+43) Austria", value: "+43" },
  { label: "(+32) Belgium", value: "+32" },
];

const CountryCode = ({ value, setCountryCode, isDisabled }) => {
  const [data, setData] = useState("+31");
  const dispatch = useDispatch();

  useEffect(() => {
    if (value) {
      setData(value);
    }
  }, [value]);

  const handleCountryChange = (val) => {
    if (!isDisabled) {
      setCountryCode(val);
      setData(val);
    }
  };

  return (
    <Select
      showSearch
      value={data}
      onChange={handleCountryChange}
      disabled={isDisabled}
      style={{
          backgroundColor: isDisabled ? "transparent" : "",
          boxShadow: "unset"
      }}
      className="country-code"
      optionFilterProp="children"
      getPopupContainer={(triggerNode) => document.body}
      dropdownStyle={{ zIndex: 2000 }}
      optionLabelProp="value"
      popupMatchSelectWidth={250}
    >
      {customCountries.map((item) => (
        <Option key={item.value} value={item.value}>
          {item.label}
        </Option>
      ))}
    </Select>
  );
};

export default CountryCode;